import { http } from '../client';
import type { CallOptions, WriteOptions } from '../types';
import type { WorkApi } from './work';
import { dossierQueueHttp } from './dossierQueue.http';
import { postOperationsHttp } from './postOperations.http';

// Paths mirror subsystems/identity/facade/adapters/admin-api/src/admin/work_items.rs.
const seg = encodeURIComponent;
const rd = (o?: CallOptions) => ({ signal: o?.signal });
const wr = (o?: WriteOptions) => ({ signal: o?.signal, idempotencyKey: o?.idempotencyKey, notifyCustomer: o?.notifyCustomer });

export const workHttp: WorkApi = {
  ...dossierQueueHttp,
  ...postOperationsHttp,
  listWorkItems: (query, opts) => http.get('api', '/work-items', { query: { ...query }, ...rd(opts) }),
  getWorkItem: (id, opts) => http.get('api', `/work-items/${seg(id)}`, rd(opts)),
  listWorkAssignees: (opts) => http.get('api', '/work-items/assignees', rd(opts)),
  assignWorkItem: (id, body, opts) => http.post('api', `/work-items/${seg(id)}/assign`, body, wr(opts)),
  resolveWorkItem: (id, body, opts) => http.post('api', `/work-items/${seg(id)}/resolve`, body, wr(opts)),
};
